import React from 'react'

const GraphLabel3 = ({color, value}) => {
  return (
    <div 
            className="graph_name G-name"
            style={{ marginLeft: "24px", width: "92%",paddingLeft:'5%' }}
          >
            <span
              style={{ backgroundColor: `${color[0]}` }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              {value[0]}
            </h5>
            <span
              style={{ backgroundColor: `${color[1]}` }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              {value[1]}
            </h5>

            <span
              style={{ backgroundColor: `${color[2]}` }}
              className="indicator"
            ></span>
            <h5 style={{ paddingLeft: "5px" }} className="ind-text">
              {value[2]}
            </h5>
          </div>
  )
}

export default GraphLabel3
